// @flow
import React from 'react';
import Diagram from '../../../components/Diagram';
import AdaptiveResultStatistics from './AdaptiveResultStatistics';
import styles from './styles.module.scss';

type Props = {
  rightResults?: number,
  allResults?: number,
  wrongResults?: number,
  onReset: () => any,
  isAdaptive?: boolean,
};

const SessionStatistics = ({
  rightResults = 0, allResults = 0, wrongResults = 0,
  onReset, isAdaptive = false,
}: Props) => {
  const right = allResults > 0 ? Math.round((100 * rightResults) / allResults) : 0;
  const wrong = allResults > 0 ? Math.round((100 * wrongResults) / allResults) : 0;
  return isAdaptive ? (
    <AdaptiveResultStatistics
      rightResults={rightResults}
      allResults={allResults}
      wrongResults={wrongResults}
      setGameResults={onReset}
    />
  ) : (
    <div className={styles.container} role="region" aria-label="Session results">
      <Diagram className={styles.diagram} percent={rightResults} base={allResults} />
      <div className={styles.resultsContainer}>
        <div className={styles.resultBlock}>
          <div className={styles.resultsWrapper}>
            <span className={styles.name}>All</span>
            <span className={styles.amount}>{allResults}</span>
          </div>
          <button
            type="button"
            className={styles.reset}
            onClick={onReset}
          >
            Reset
          </button>
        </div>
        <div className={styles.resultBlock}>
          <div className={styles.resultsWrapper}>
            <span className={styles.correct}>Correct</span>
            <div className={styles.amountWrapper}>
              <span className={styles.amount}>{rightResults}</span>
              <span className={styles.percent}>{`(${right}%)`}</span>
            </div>
          </div>
          <div className={styles.resultsWrapper}>
            <span className={styles.wrong}>Wrong</span>
            <div className={styles.amountWrapper}>
              <span className={styles.amount}>{wrongResults}</span>
              <span className={styles.percent}>{`(${wrong}%)`}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionStatistics;
